import _ from '@lodash';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';

function EditFormGroupFields(props) {
	const methods = useFormContext();
	const { control, watch } = methods;
	const watchAllFields = watch();

	return (
		<div className={props.fieldConfig.className}>
			{props.fieldConfig.fields
				? props.fieldConfig.fields.map(fieldRow =>
						_.isUndefined(fieldRow.visibleIf) || fieldRow.visibleIf(watchAllFields, methods) ? (
							_.isUndefined(fieldRow.fields) || fieldRow.isControlledInput === false ? (
								<Controller
									key={fieldRow.key}
									name={fieldRow.key}
									control={control}
									render={({ field, fieldState }) => <fieldRow.component field={field} fieldState={fieldState} config={props.config} fieldConfig={fieldRow} className={fieldRow.className} />}
								/>
							) : (
								<fieldRow.component key={fieldRow.key} config={props.config} fieldConfig={fieldRow} />
							)
						) : null
				  )
				: null}
		</div>
	);
}

export default EditFormGroupFields;
